import { baseApi } from "./baseApi";

const loanPricingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    quotePricingScenarios: builder.mutation({
      query: ({ loanId, body }) => ({
        url: `/loans/${loanId}/pricing/quote-scenarios`,
        method: "POST",
        body,
      }),
    }),
    getQuoteScenariosStatus: builder.query({
      query: ({ loanId, jobId }) => ({
        url: `/loans/${loanId}/pricing/quote-scenarios/${jobId}`,
        method: "GET",
      }),
    }),
    selectPricingQuote: builder.mutation({
      query: ({ loanId, body }) => ({
        url: `/loans/${loanId}/pricing/select-quote`,
        method: "POST",
        body,
      }),
    }),
    getSelectQuoteStatus: builder.query({
      query: ({ loanId, jobId }) => ({
        url: `/loans/${loanId}/pricing/select-quote/${jobId}`,
        method: "GET",
      }),
    }),
    requestRateLock: builder.mutation({
      query: ({ loanId, body }) => ({
        url: `/loans/${loanId}/pricing/request-rate-lock`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "Loan", id: loanId },
      ],
    }),
    getRateLockStatus: builder.query({
      query: ({ loanId, jobId }) => ({
        url: `/loans/${loanId}/pricing/request-rate-lock/${jobId}`,
        method: "GET",
      }),
    }),
    approveLock: builder.mutation({
      query: ({ loanId }) => ({
        url: `/loans/${loanId}/pricing/approve-lock`,
        method: "POST",
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "Loan", id: loanId },
      ],
    }),
    getApproveLockStatus: builder.query({
      query: ({ loanId, jobId }) => ({
        url: `/loans/${loanId}/pricing/approve-lock/${jobId}`,
        method: "GET",
      }),
    }),
    cancelLock: builder.mutation({
      query: ({ loanId }) => ({
        url: `/loans/${loanId}/pricing/cancel-lock`,
        method: "POST",
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "Loan", id: loanId },
      ],
    }),
    getCancelLockStatus: builder.query({
      query: ({ loanId, jobId }) => ({
        url: `/loans/${loanId}/pricing/cancel-lock/${jobId}`,
        method: "GET",
      }),
    }),
    extendLock: builder.mutation({
      query: ({ loanId, body }) => ({
        url: `/loans/${loanId}/pricing/extend-lock`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "Loan", id: loanId },
      ],
    }),
    getExtendLockStatus: builder.query({
      query: ({ loanId, jobId }) => ({
        url: `/loans/${loanId}/pricing/extend-lock/${jobId}`,
        method: "GET",
      }),
    }),
    requestExtension: builder.mutation({
      query: ({ loanId, body }) => ({
        url: `/loans/${loanId}/pricing/request-extension`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "Loan", id: loanId },
      ],
    }),
    getRequestExtensionStatus: builder.query({
      query: ({ loanId, jobId }) => ({
        url: `/loans/${loanId}/pricing/request-extension/${jobId}`,
        method: "GET",
      }),
    }),
    requestConcession: builder.mutation({
      query: ({ loanId, body }) => ({
        url: `/loans/${loanId}/pricing/request-concession`,
        method: "POST",
        body,
      }),
    }),
    getRequestConcessionStatus: builder.query({
      query: ({ loanId, jobId }) => ({
        url: `/loans/${loanId}/pricing/request-concession/${jobId}`,
        method: "GET",
      }),
    }),
    approveConcession: builder.mutation({
      query: ({ loanId }) => ({
        url: `/loans/${loanId}/pricing/approve-concession`,
        method: "POST",
      }),
    }),
    getApproveConcessionStatus: builder.query({
      query: ({ loanId, jobId }) => ({
        url: `/loans/${loanId}/pricing/approve-concession/${jobId}`,
        method: "GET",
      }),
    }),
    requestReprice: builder.mutation({
      query: ({ loanId, body }) => ({
        url: `/loans/${loanId}/pricing/request-reprice`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "Loan", id: loanId },
      ],
    }),
    getRepriceStatus: builder.query({
      query: ({ loanId, jobId }) => ({
        url: `/loans/${loanId}/pricing/request-reprice/${jobId}`,
        method: "GET",
      }),
    }),
    approveReprice: builder.mutation({
      query: ({ loanId }) => ({
        url: `/loans/${loanId}/pricing/approve-reprice`,
        method: "POST",
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "Loan", id: loanId },
      ],
    }),
    getApproveRepriceStatus: builder.query({
      query: ({ loanId, jobId }) => ({
        url: `/loans/${loanId}/pricing/approve-reprice/${jobId}`,
        method: "GET",
      }),
    }),
    withdrawPricingRequest: builder.mutation({
      query: ({ loanId, body }) => ({
        url: `/loans/${loanId}/pricing/withdraw-request`,
        method: "POST",
        body,
      }),
    }),
    getWithdrawRequestStatus: builder.query({
      query: ({ loanId, jobId }) => ({
        url: `/loans/${loanId}/pricing/withdraw-request/${jobId}`,
        method: "GET",
      }),
    }),
    updateProgramName: builder.mutation({
      query: ({ loanId, body }) => ({
        url: `/loans/${loanId}/pricing/program-name`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "Loan", id: loanId },
      ],
    }),
    submitPostLockRequest: builder.mutation({
      query: ({ loanId, body }) => ({
        url: `/loans/${loanId}/pricing/submit-post-lock-request`,
        method: "POST",
        body,
      }),
    }),
    submitCocRequest: builder.mutation({
      query: ({ loanId, body }) => ({
        url: `/loans/${loanId}/pricing/submit-coc-request`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export default loanPricingApi;
